// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "Pruthvi central school,Yargati",
    contact: "+91 9108444311 | pruthvicentralschoolpcs@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/p/DXlgD84l-Wo/?igsh=MW1nbmYycDhwajJ5aQ==",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/watch?v=WClQEbTekfU",
      facebook:   "https://www.facebook.com/share/15eM7V2xp1/",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
